import { TERTIARY, getDarkColor, makeThemeColor } from '@tornado-rdk/theme';
import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { makeDefaultStylingContext } from '../../../tornado/utils/style';
import { SCREEN_WIDTH, SCREEN_HEIGHT } from '../../../tornado/utils/sizes';
import { TRANSPARENT } from '../../../tornado/utils/colors';

const defaultContext = makeDefaultStylingContext();

export const colors = {
  background: makeThemeColor(TERTIARY),
};

export const background = {
  [HD]: {
    w: SCREEN_WIDTH[HD],
    h: SCREEN_HEIGHT[HD],
  },
  [FULL_HD]: {
    w: SCREEN_WIDTH[FULL_HD],
    h: SCREEN_HEIGHT[FULL_HD],
  },
};

export const gradient = {
  [HD]: {
    w: SCREEN_WIDTH[HD],
    h: Math.round(SCREEN_HEIGHT[HD] * 0.25),
  },
  [FULL_HD]: {
    w: SCREEN_WIDTH[FULL_HD],
    h: Math.round(SCREEN_HEIGHT[FULL_HD] * 0.25),
  },
};

export const getInitialStyle = ({ screenSize, colorMode } = defaultContext) => ({
  ...background[screenSize],
  rect: true,
  color: getDarkColor(TERTIARY, 0.6),
  Top: {
    ...gradient[screenSize],
    rect: true,
    colorTop: colors.background[colorMode],
    colorBottom: TRANSPARENT,
  },
  Bottom: {
    ...gradient[screenSize],
    rect: true,
    y: background[screenSize].h - gradient[screenSize].h,
    colorTop: TRANSPARENT,
    colorBottom: colors.background[colorMode],
  },
});
